import { render, staticRenderFns } from "./AttemptView.vue?vue&type=template&id=70a593f8&scoped=true"
import script from "./AttemptView.vue?vue&type=script&lang=js"
export * from "./AttemptView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a593f8",
  null
  
)

export default component.exports